import React from 'react';
import { Link } from 'react-router-dom';
import queryString from 'query-string';

export default () => {
    const parsed = queryString.parse(window.location.search);
    const registrationCode = parsed.registrationCode;
    return (
        <div className="message">
            <h1>Success</h1>
            <p>Your application has been successfully submitted.</p>
            {registrationCode && (
                <p>
                    Your registration code is{' '}
                    <strong>{registrationCode}</strong>. Keep this for future
                    reference.
                </p>
            )}
            <p>
                If you are seeing this page then your enrolment has been
                received.
            </p>
            <p>
                <strong>
                    We will manually confirm that your enrolment has been
                    accepted via email. If you do not receive this email within
                    2 weeks please email programme@cfbs.org.nz.
                </strong>
            </p>
            <p>
                Registration is not final until fees have been paid. If you need
                assistance with fees, please contact us at programme@cfbs.org.nz
            </p>
            <p>
                We will also be in touch with further details closer to the
                School.
            </p>
            <p>God willing, we will see you at the School.</p>
            <p>
                <Link to="/">Register Others?</Link>
            </p>
        </div>
    );
};
